import React from "react";
import { Swatch } from "../types"

type Props = {
  selectedColour?: string;
  colourOptions: string[];
  swatches: Swatch[];
  handleColorClick: (colour: string) => void;
  maxColourSwatches?: number
  swatchStyle: React.HTMLAttributes<HTMLSpanElement>["style"]
}

export const ProductSwatches: React.FC<Props> = ({ selectedColour, colourOptions, swatches, handleColorClick, maxColourSwatches = 99999, swatchStyle }) => {
  return colourOptions?.length > 0 ? (
    <>
      {colourOptions.slice(0, maxColourSwatches).map((colour: any) => {
        const swatch = swatches.find(swatch => swatch?.name == colour)
        return (
          <span
            className={`rs__result-card-product__colour ${selectedColour === colour ? "selected" : ""}`}
            onClick={() => handleColorClick(colour)}
            style={{
              ...swatchStyle, 
              border: selectedColour === colour ? "1px solid grey" : "none",
            }}
          >
            <span style={{ 
              backgroundColor: `${swatch?.colour || "rgba(0,0,0,0.05)"}`,
              backgroundImage: swatch?.image ? `url(${swatch?.image})` : undefined 
            }}></span>
          </span>
        )
      })}

      {colourOptions.length > maxColourSwatches && (
        <span>+ {colourOptions.length - maxColourSwatches} more</span>
      )}
    </>
  ) : null
}